import { Text, Img, Heading } from "../../components";
import React from "react";
import {
  AccordionItemPanel,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemState,
  Accordion,
  AccordionItem,
} from "react-accessible-accordion";

// Accordion data with specific answers for each question
const accordionData = [
  {
    questionTitle: "How can I discuss a specific case study in more detail?",
    answer:
      "If you’re interested in discussing a particular case study or have questions about implementation, please contact our team. We’re happy to provide further insights and facilitate a deeper conversation about how our solutions can benefit your organization.",
  },
  {
    questionTitle: "Is Zwilling Labs Digital Twin solution scalable for future expansion?",
    answer:
      "Yes, Zwilling Labs' platform is designed to be standardized and scalable. This means you can adopt a step-by-step approach to seamlessly expand the number or type of IoT devices, add new machine types, or integrate additional shop floors and factories into the Digital Twin platform as your needs grow.",
  },
  {
    questionTitle: "What are the key takeaways from the case studies?",
    answer:
      "Our case studies highlight that proactive leadership, effective management, and an informed workforce are crucial for successful digitalization. Combining a thorough engineering analysis of challenges with advanced AI-driven, targeted monitoring leads to more resilient and comprehensive solutions.",
  },
  {
    questionTitle: "Which industries does Zwilling Labs mainly target?",
    answer:
      "Zwilling Labs caters to a wide range of industries, including raw material manufacturers (e.g., steel), tool manufacturers, finished goods producers (e.g., tires and automotive), and high-value or critical-asset sectors such as defense and aerospace.",
  },
  {
    questionTitle: "Are the case studies based on real client projects?",
    answer:
      "Yes, our case studies reflect work delivered for prestigious clients both in India and internationally. We continuously seek to expand our client base by taking on challenging projects and proof-of-concept (PoC) initiatives, aligning with user expectations, and delivering exceptional solutions.",
  },
];

export default function FAQSection() {
  return (
    <>
      {/* FAQ section */}
      <div className="mb-[70px] py-[60px] flex flex-col items-center">
        <div className="container-xs flex flex-col gap-[130px] px-14 sm:px-4 md:gap-[97px] md:px-5 sm:gap-[65px]">
          <div className="mr-2 flex flex-col items-center gap-4  md:mr-0 md:px-5">
            <Heading
              size="heading7xl"
              as="h2"
              className="text-[24px] font-bold uppercase tracking-[2.40px] text-amber-800_01 md:text-[22px]"
            >
              FAQ
            </Heading>
            <Heading
              size="heading9xl"
              className="font-bold text-center text-color_style-01_neutrals-grey800 md:text-[42px] sm:text-[21px]"
            >
              Frequently Asked Questions
            </Heading>
            <Text
              size="text9xl"
              as="p"
              className="self-stretch text-center font-normal leading-10 text-blue_gray-700_01 md:text-[24px] sm:text-[22px]"
            >
              Learn more about our Digital Twin platform, including their content, access, and industry relevance.
            </Text>
          </div>
          <Accordion preExpanded={[0]} className="flex flex-col gap-[88px]">
            {accordionData.map((item, index) => (
              <AccordionItem uuid={index} key={`faq-item-${index}`}>
                <div className="flex-1">
                  <AccordionItemHeading className="w-full">
                    <AccordionItemButton className="w-full flex items-center justify-between gap-5">
                      <Heading
                        size="heading9xl"
                        as="h4"
                        className="font-bold text-color_style-01_neutrals-grey800 md:text-[30px] sm:text-[28px]"
                      >
                        {item.questionTitle}
                      </Heading>
                      <AccordionItemState>
                        {(props) => (
                          <>
                            {props?.expanded ? (
                              <Img
                                src="images/img_arrow_down.svg"
                                alt="Arrow Icon"
                                className="h-[60px] w-[6%] object-contain md:w-[60px] sm:w-[50px]"
                              />
                            ) : (
                              <Img
                                src="images/img_plus.svg"
                                alt="Plus Icon"
                                className="h-[60px] w-[6%] object-contain md:w-[60px] sm:w-[50px]"
                              />
                            )}
                          </>
                        )}
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>
                      <Text
                        size="text9xl"
                        as="p"
                        className="font-normal leading-10 text-color_style-01_neutrals-grey700 md:text-[24px] sm:text-[22px]"
                      >
                        {item.answer}
                      </Text>
                    </div>
                  </AccordionItemPanel>
                </div>
                <div className="h-[2px] w-full bg-blue-100" />
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </>
  );
}
